export enum Severity {
  Warning = "Warning",
  Info = "Info",
  Error = "Error",
  Success = "Success",
}

export class Log {
  public message: string | null = null;
  public severity: Severity | null = null;
  public data: object | null = null;
  public dateTime: Date | null = null;
}
